import React from 'react';
import { getPurchaseWorkflow } from '../utils/purchaseWorkflow';

export default function usePurchaseWorkflow() {
  const [startStage, setStartStage] = React.useState('PR');
  const [loading, setLoading] = React.useState(true);
  React.useEffect(() => {
    const load = () => getPurchaseWorkflow().then((data) => setStartStage(data.startStage)).finally(() => setLoading(false));
    load();
    window.addEventListener('purchase-workflow-changed', load);
    return () => window.removeEventListener('purchase-workflow-changed', load);
  }, []);
  return { startStage, loading };
}
